import { FontBackgroundColorPlugin } from '@platejs/basic-styles/react';
import { KEYS } from 'platejs';

import BackgroundColorIcon from '../../../../../icons/background-color.svg?react';
import { ColorPopoverControl } from './shared';

export const backgroundColorPlugin = FontBackgroundColorPlugin.configure({
  inject: { targetPlugins: [KEYS.p] },
});

const BACKGROUND_COLOR_MARK = backgroundColorPlugin.key;

export const BackgroundColorToolbarControl = ({
  label = 'Background color',
  clearLabel = 'Clear background color',
}: {
  label?: string;
  clearLabel?: string;
}) => {
  return (
    <ColorPopoverControl
      clearLabel={clearLabel}
      icon={BackgroundColorIcon}
      label={label}
      markKey={BACKGROUND_COLOR_MARK}
    />
  );
};
